import { IconButton, Dialog } from "@mui/material";
import CustomFilterInput from "../../../shared/CustomFilterInput";
import AppButton from "../../../shared/AppButton";
import React, { useState, useEffect, useContext } from "react";
import * as Yup from "yup";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import AppModal from "../../../components/AppModal";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { useFormik } from "formik";
// import claims from "../../../gql/claims";
import { useQuery, useMutation } from "@apollo/client";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import SaveIcon from "@mui/icons-material/Save";
import ptpa from "../../../gql/ptpa";
// import LoadingButton from "@mui/lab/LoadingButton";
import toast from "react-hot-toast";
import { appContext } from "../../../context/ContextProvider";
import gqlClaims from "../../../gql/claims";
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function ClaimsSubmitModal({
  open,
  handleClose,
  selectedValues,
  setSelectedValues,
  refetch,
  data,
  setSubmitClaimData,
  setTotalPages,
  setTotalSubmits,
}) {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  const [payers, setPayers] = useState([]);

  const { setShowLoader, setShowErrorAlert } = useContext(appContext);
  const [errorData, setErrorData] = useState([]);

  const currentDate = new Date();

  //   console.log(selectedValues);

  const [fromDate, setFromDate] = useState(
    `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(
      2,
      "0",
    )}-01`,
  );
  const [toDate, setToDate] = useState(
    `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(
      2,
      "0",
    )}-${new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0,
    ).getDate()}`,
  );

  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);

  // const {
  //   loading: dataLoading,
  //   error,
  //   data,
  //   refetch,
  // } = useQuery(gqlClaims.GET_PAYER_CLAIMS, {
  //   variables: {
  //     input: {
  //       from_date: fromDate,
  //       to_date: toDate,
  //       status: "Ready for submission",
  //       limit: limit,
  //       page: pageNo,
  //     },
  //   },
  // });

  const [
    submitClaims,
    { data: addData, loading: addLoading, error: addError },
  ] = useMutation(gqlClaims.SUBMIT_CLAIMS, {
    update(proxy, result) {
      onSuccessfulRequestResponse(result.data);
    },
    onError(error) {
      onResponseError(error.graphQLErrors[0]);
    },
  });

  const onSuccessfulRequestResponse = (data) => {
    if (!data.submitClaims.nphies_err) {
      toast.dismiss();
      toast.success("Successfully Requested!");
      setSelectedValues([]);
      handleClose();
      refetch({
        input: {
          from_date: fromDate,
          to_date: toDate,
          status: "Ready for submission",
          limit: limit,
          page: pageNo,
        },
      }).then((res) => {
        if (res?.data?.listPayerClaims?.data) {
          setSubmitClaimData(res?.data?.listPayerClaims?.data);
          setTotalPages(res?.data?.listPayerClaims?.pages);
          setTotalSubmits(res?.data?.listPayerClaims?.total);
        }
      });
    } else {
      toast.dismiss();
      let tempErrors = [
        {
          Code: "DT-01293",
          ValueString: "Bundle.entry[1].resource.supportingInfo[0].timingDate",
          Display:
            "The provided value does not match the specified element data type",
          __typename: "SimpleEligibilityNphiesErr",
        },
      ];
      setErrorData(data?.submitClaims?.nphies_err);
      setShowErrorAlert(true);
      handleClose();
    }
  };

  const onResponseError = (error) => {
    toast.dismiss();
    toast.error(`${error.message}`);
    setSelectedValues([]);
    handleClose();
    refetch({
      input: {
        from_date: fromDate,
        to_date: toDate,
        status: "Ready for submission",
        limit: limit,
        page: pageNo,
      },
    }).then((res) => {
      if (res?.data?.listPayerClaims?.data) {
        setSubmitClaimData(res?.data?.listPayerClaims?.data);
        setTotalPages(res?.data?.listPayerClaims?.pages);
        setTotalSubmits(res?.data?.listPayerClaims?.total);
      }
    });
  };

  const formik = useFormik({
    initialValues: {
      is_batch: false,
      batch_start_date: "",
      batch_end_date: "",
    },
    validationSchema: Yup.object({
      is_batch: Yup.boolean().required(t("Is Batch Required")),

      batch_start_date: Yup.string().test(
        "is-batch",
        t("Batch Start Date Required"),
        function (value) {
          if (this.parent.is_batch) {
            return !!value;
          }
          return true;
        },
      ),

      batch_end_date: Yup.string().test(
        "is-batch",
        t("Batch End Date Required"),
        function (value) {
          if (this.parent.is_batch) {
            return !!value;
          }
          return true;
        },
      ),
    }),

    onSubmit: async (values) => {
      if (data?.listPayerClaims?.data.length > 0 && selectedValues.length > 0) {
        toast.loading("Requesting!");
        submitClaims({
          variables: {
            // input: replaceEmptyStringWithNull(formatInputData(postData)), //temp
            input: { id: selectedValues, ...values },
          },
        }).then((res) => {
          console.log(res);
          // refetch({
          //   input: {
          //     from_date: fromDate,
          //     to_date: toDate,
          //     status: "Ready for submission",
          //     limit: limit,
          //     page: pageNo,
          //   },
          // });
        });
      }
      formik.resetForm();
    },
  });

  const downloadExcelFile = (data, fileName) => {
    const workbook = XLSX.utils.book_new();
    const sheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(fileData, `${fileName}.xlsx`);
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className:
            "w-full sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl !z-40",
        }}
      >
        {/* ── Header ── */}
        <div className="flex items-center justify-between px-3 py-2 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <div className="flex items-center justify-center w-6 h-6 rounded bg-[#e8f2fb]">
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#0070C2"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="9" y1="13" x2="15" y2="13" />
                <line x1="9" y1="17" x2="12" y2="17" />
              </svg>
            </div>
            <span className="text-[15px] font-semibold text-gray-700">
              {t("Submit Claim")}
            </span>
          </div>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            size="small"
            sx={{ color: "#9ca3af", padding: "2px" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
        {/* ── Body ── */}
        <DialogContent sx={{ p: "12px 14px" }}>
          <div className="grid grid-cols-2 gap-2">
            <div className="col-span-2">
              <div className="toggle-button-ref claims-submit-toggle flex gap-2 items-center">
                <input
                  type="checkbox"
                  name="is_batch"
                  onChange={() =>
                    formik.setFieldValue("is_batch", !formik.values.is_batch)
                  }
                  id="is_batch"
                  checked={formik.values.is_batch}
                />
                <label htmlFor="is_batch"></label>
                <span className="text-[12px] font-medium text-gray-700">
                  {t("Is Batch")}
                </span>
              </div>
            </div>

            {formik?.values?.is_batch && (
              <div>
                <CustomFilterInput
                  label={t("Batch Start Date*")}
                  placeholder={t("Batch Start Date*")}
                  type="date"
                  name="batch_start_date"
                  value={formik.values.batch_start_date}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={!formik.values.is_batch}
                  id="batch_start_date"
                  autoComplete="off"
                  error={formik.errors.batch_start_date}
                  touched={formik.touched.batch_start_date}
                />
              </div>
            )}

            {formik?.values?.is_batch && (
              <div>
                <CustomFilterInput
                  label={t("Batch End Date*")}
                  placeholder={t("Batch End Date*")}
                  type="date"
                  name="batch_end_date"
                  value={formik.values.batch_end_date}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={!formik.values.is_batch}
                  id="batch_end_date"
                  autoComplete="off"
                  error={formik.errors.batch_end_date}
                  touched={formik.touched.batch_end_date}
                />
              </div>
            )}
          </div>
        </DialogContent>
        {/* ── Footer ── */}
        <div className="flex items-center justify-end gap-2 px-3 py-2 border-t border-gray-100">
          <AppButton
            variant="outlined"
            onClick={handleClose}
            label={t("Cancel")}
            className="!text-gray-600 !border-gray-300 hover:!bg-gray-50"
          />
          <AppButton
            onClick={() => {
              handleClose();
              formik.handleSubmit();
            }}
            isLoading={loading || addLoading}
            label={t("Submit")}
            loadingText="Submitting..."
          />
        </div>
      </BootstrapDialog>

      <AppModal isOpen={loading || addLoading} />
      <style>{`
        .claims-submit-toggle label {
          width: 36px !important;
          height: 20px !important;
        }
        .claims-submit-toggle label:before {
          width: 36px !important;
          height: 20px !important;
          background-color: #99c9e8 !important;
        }
        .claims-submit-toggle label:after {
          width: 14px !important;
          height: 14px !important;
          top: 3px !important;
          left: 3px !important;
        }
        .claims-submit-toggle input[type='checkbox']:checked + label:after {
          transform: translateX(16px) !important;
        }
        .claims-submit-toggle input[type='checkbox']:checked + label:before {
          background-color: #0070C2 !important;
        }
      `}</style>
    </div>
  );
}
